import $ from 'jquery';


let mailchimp = {
  formElement: null,
  formClassName: '.email-subscription__form',

  init() {
    this.formElement = document.getElementById("mailchimpForm");

    if (!theme_config.mailchimp_api_key) {
      $(this.formClassName).html("<small>Please add a mailchimp api key in theme settings area</small>");
      return;
    }

    $(this.formClassName).on("submit", (e) => {
      e.preventDefault();
      this.subscribeUser();
    });
  },
  subscribeUser() {
    const email = $(this.formClassName).find("input").val();
    $(this.formClassName).find("button").prop("disabled", true);
    $(this.formClassName).addClass("loading").removeClass("success").removeClass("error");
    const result = $.ajax({
      method: "POST",
      url: api_url.mailchimp,
      dataType: "json",
      data: {
        email: email,
      },
      success: (response) => {
        $(".mailchimp_form__msg").html(response.message).fadeIn().parent().addClass("success");
        $(this.formClassName).find("button").prop("disabled", false);
        $(this.formClassName).removeClass("loading");
        this.formElement.reset();
        setTimeout(() => {
          $(".mailchimp_form__msg").fadeOut();
          console.log('email:', email);
        }, 5000);
      },
      error: (xhr, status, error) => {
        const err = JSON.parse(xhr.responseText);
        $(".mailchimp_form__msg").html(err.message).fadeIn().parent().addClass("error");
        $(this.formClassName).find("button").prop("disabled", false);
        $(this.formClassName).removeClass("loading");
        this.formElement.reset();
        setTimeout(() => {
          $(".mailchimp_form__msg").fadeOut();
        }, 5000);
      },
    });
  },
};
export default mailchimp;

// b3fa75630cab4fd29050f6945aa64e48-us2

// audience_id 4b2458700e
